@if (isShowing) {
  <div class="modal-backdrop blocking-overlay-backdrop" @enterLeaveFadeAnimation>
    <div class="modal" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
      <icon name="x" class="close-icon" (click)="handleModalClose()" tabindex="0"></icon>
      <div class="modal-content">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
}